import React, { useState } from 'react'

import data from 'mocks/navbar.mock'

import * as S from './styles'
import { Navbar, NavItem, NavList } from 'component-library/navbar'
import { Button } from 'component-library/button'
import { useModalContext } from 'contexts/modal'
import { Icon } from 'component-library/icon'
import { ConditionallyRender } from 'components/utilities/conditionally-render'
import { UserButtonWrapper } from './styles'

export default () => {
  const { setIsOpened, isUserLoggedIn } = useModalContext()

  const [isFloatContainerOpened, setIsFloatContainerOpened] = useState(false)
  const [isLogoutSelectOpened, setIsLogoutSelectOpened] = useState(false)

  const handleNavItem = (option: any) => {
    setIsFloatContainerOpened(!isFloatContainerOpened)

    window.open(option.source, '_blank')
  }

  const handleSignOut = () => {
    window.dispatchEvent(new Event('handleNavbarSignOut'))
    setIsLogoutSelectOpened(false)
  }

  return (
    <Navbar
      isFloatContainerOpened={!!isFloatContainerOpened}
      handleFloatContainerClick={() =>
        setIsFloatContainerOpened(!isFloatContainerOpened)
      }
      userActionElement={
        <UserButtonWrapper>
          <Button
            className="user"
            variant="secondary"
            borderType="medium"
            handleClick={() =>
              !!isUserLoggedIn
                ? setIsLogoutSelectOpened(!isLogoutSelectOpened)
                : setIsOpened(true)
            }
            iconElement={<Icon name="user" color="#DF1D3D" size={24} />}
          />

          <ConditionallyRender
            shouldRender={!!isLogoutSelectOpened}
            content={
              <S.LogoutOptionWrapper onClick={handleSignOut}>
                <S.LogoutOptionLabel>Sair</S.LogoutOptionLabel>
              </S.LogoutOptionWrapper>
            }
          />
        </UserButtonWrapper>
      }
      navOptionsCompositions={data.navOptions.map((item) => (
        <NavItem
          key={`nav-option-item-${item.label}`}
          label={item.label}
          handleClick={() => window.open(item.source, '_blank')}
        />
      ))}
      floatContainerComposition={
        <S.Container>
          <NavList
            direction="vertical"
            content={data.navOptions.map((option, index) => (
              <NavItem
                key={`nav-item-${index}`}
                label={option.label}
                handleClick={() => handleNavItem(option)}
              />
            ))}
          />

          <S.ButtonsWrapper>
            {data.content.map((btn) => (
              <Button
                key={btn.label}
                label={btn.label}
                isFullyAdaptative
                variant={btn?.buttonVariant!}
                handleClick={() => window.open(btn.source, '_blank')}
              />
            ))}
          </S.ButtonsWrapper>
        </S.Container>
      }
    />
  )
}
